import React from "react";
import PropTypes from "prop-types";
import { Avatar, IconButton, Box } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

const UpdateProfilePicture = ({
  currentImage,
  onImageSelect,
  avatarSize = 120,
  avatarStyle = {},
  iconStyle = {},
}) => {
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onImageSelect(file);
    }
  };

  return (
    <Box
      position="relative"
      display="inline-block"
      sx={{ width: avatarSize, height: avatarSize }}
    >
      <input
        accept="image/*"
        type="file"
        id="upload-profile-picture"
        style={{ display: "none" }}
        onChange={handleImageChange}
      />
      <label htmlFor="upload-profile-picture" style={{ cursor: "pointer" }}>
        <Avatar
          src={currentImage}
          sx={{
            width: avatarSize,
            height: avatarSize,
            border: "2px solid #fff",
            boxShadow: 2,
            objectFit: "cover",
            ...avatarStyle,
          }}
          alt="Profile Picture"
        />
        <IconButton
          component="span"
          sx={{
            position: "absolute",
            bottom: 8,
            right: 12,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            color: "white",
            borderRadius: "50%",
            width: 32,
            height: 32,
            boxShadow: 3,
            transition: "0.3s",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              boxShadow: 5,
            },
            ...iconStyle,
          }}
          aria-label="Upload new profile picture"
        >
          <PhotoCameraIcon fontSize="small" />
        </IconButton>
      </label>
    </Box>
  );
};

UpdateProfilePicture.propTypes = {
  currentImage: PropTypes.string,
  onImageSelect: PropTypes.func.isRequired,
  avatarSize: PropTypes.number,
  avatarStyle: PropTypes.object,
  iconStyle: PropTypes.object,
};

export default UpdateProfilePicture;
